<template>
    <div class="weui-footer" v-show="!footer.hidden">
        <!-- <router-link to="#">
            <img src="http://www.runoob.com/wp-content/uploads/2016/04/trolltunga.jpg" class="banner">
        </router-link> -->
        <div class="weui-flex" style="padding: 5px 10px 5px 10px">
            <div class="weui-flex__item" style="text-align:left">&copy; 一说春秋&trade;</div>
            <div class="weui-flex__item" style="text-align:right">
                <!-- <ul class="weui-media-box__info">
                        <li class="weui-media-box__info__meta">文字来源</li>
                        <li class="weui-media-box__info__meta">时间</li>
                        <li class="weui-media-box__info__meta weui-media-box__info__meta_extra">其它信息</li>
                    </ul> -->
                <router-link v-for="(button, index) in footer.buttons" :key="index" 
                    class="weui-media-box__info__meta" :class="index != 0 ? 'weui-media-box__info__meta_extra' : ''"
                    :to="button.route">{{button.title}}</router-link> 
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "WeuiFooter",
    computed: {
        footer() {
            return this.$store.state.weui.footer;
        }
    }
}
</script>

<style scoped>
    .banner {
        max-width: 100%;
        height: auto;
    }
</style>
